import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { OpennessGrid, OPENNESS_DEFAULTS } from '../website/OpennessComparison';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Configurator shortcut: same comparison block, using the CMS copy published on the Solar Shades page.
export const OpennessCompareDialog = () => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState({});
  useEffect(() => {
    if (!open) return;
    axios.get(`${API_URL}/website/page/solar-shades`).then((r) => {
      const s = (r.data.sections || []).find((x) => x.type === 'openness_comparison');
      if (s) setContent(s.props || {});
    }).catch(() => {});
  }, [open]);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="basis-full text-left mt-1 text-xs text-amber-700 underline underline-offset-2 hover:text-amber-900" data-testid="compare-openness-link">
        Compare openness
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-6xl w-[96vw] max-h-[92vh] overflow-y-auto" data-testid="compare-openness-dialog">
          <DialogHeader>
            <DialogTitle>{content.title || OPENNESS_DEFAULTS.title}</DialogTitle>
            <DialogDescription>{content.intro || OPENNESS_DEFAULTS.intro}</DialogDescription>
          </DialogHeader>
          {open && <OpennessGrid content={content} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
